module.exports = __webpack_public_path__ + "static/media/alien.72177bc0.svg";